// extracted by mini-css-extract-plugin
module.exports = {"overlay":"navigation-drawer_overlay__tGO22","isOpen":"navigation-drawer_isOpen__3hray","drawer":"navigation-drawer_drawer__2XMYb"};